import React, { Component, useEffect, useRef, useState } from "react";

import { CLink, CButton } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import StudentView from "../../../../components/Trail/View/StudentView";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

function TrailDo({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [trail, setTrail] = useState(null);
  const [name, setName] = useState(null);
  const [description, setDescription] = useState(null);
  const [user, setUser] = useState({});
  const [currentStep, setCurrentStep] = useState(null);
  const [totalSteps, setTotalSteps] = useState(null);
  const [maxStepAvailable, setMaxStepAvailable] = useState(1);
  const [isFirstReq, setIsFirstReq] = useState(true);

  const currentPath = useLocation();

  const ref = useRef(null);

  useEffect(() => {
    props.setObj(16, props.currentRoute, props.currentRoute);

    getTrail();
  }, []);

  const handleStep = (step, direction) => {
    if (isFirstReq) {
      setIsFirstReq(false);
      if (
        direction === "down" &&
        step > maxStepAvailable &&
        step <= totalSteps
      ) {
        setMaxStepAvailable(step);
      }
    }
    setCurrentStep(step);
    getTrail();
  };

  const getTrail = currentStep => {
    const searchParams = currentPath.search
      .substring(1)
      .split("&")
      .reduce(
        (acc, cur) => ({
          ...acc,
          [cur.split("=")[0]]: cur.split("=")[1]
        }),
        {}
      );

    let url =
      searchParams?.partialprogression === "true"
        ? `${URL.api}activity/trail_allocation/partial_progression/showByStep/${props.match.params.allocation_id}`
        : `${URL.api}activity/trail_allocation/showByStep/${props.match.params.allocation_id}`;

    if (!isFirstReq) {
      url = `${url}?step=${currentStep}`;
    }
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            setLoading(false);
            setTotalSteps(resp.data.meta.totalSteps);
            setCurrentStep(resp.data.meta.currentStep);
            setMaxStepAvailable(
              isFirstReq ? resp.data.meta.currentStep : maxStepAvailable
            );
            setTrail(resp.data.data.trail);
            setName(resp.data.data.trail?.name);
            setDescription(resp.data.data.trail?.description);
            setUser(resp.data.data.user);
          } else {
            toastr.error("Falha", "Não foi possível ver a trilha");
            setLoading(false);
          }
        },
        error => {
          toastr.error("Falha", "Não foi possível ver a trilha");
          setLoading(false);
        }
      );
  };

  return (
    <div
      className="w-100 h-100 flex-column bg-light flex-1 d-flex align-items-center justify-content-start position-relative"
      ref={ref}
    >
      <div
        className="d-flex w-100 bg-white"
        style={{
          zIndex: 1000,
          borderBottom: "1px solid rgba(0, 0, 0, 0.125)"
        }}
      >
        <div className="flex-1 trail-nav px-4 py-3">
          <h2
            className="d-flex align-items-center mb-1"
            style={{ borderBottom: "1px solid white" }}
          >
            {!loading ? name : "Carregando trilha..."}
            <CButton
              color="light"
              className="ml-3"
              size="sm"
              onClick={() => props.history.push("/dashboard")}
            >
              Sair
            </CButton>
          </h2>
          <div className="d-flex align-items-center">
            <img
              src={URL.img + (user?.photo || "uploads/users/profileEmpty.jpg")}
              style={{
                borderRadius: "100%",
                width: "24px",
                height: "24px",
                marginRight: "0.75rem"
              }}
            />
            <CLink to={`/profile/${user.id}`}>
              {user?.name || "Carregando..."}
            </CLink>
            {!loading && (
              <>
                <span className="text-light mx-3">|</span>
                <span className="text-muted">
                  {!loading ? description : "Aguarde mais um pouco"}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      {loading ? (
        <div className="screen align-items-center justify-items-center">
          <Loading />
        </div>
      ) : (
        <StudentView
          userId={props.user.user.id}
          userName={props.user.user.username}
          trail={trail}
          allocation_id={props.match.params.allocation_id}
          handleStep={handleStep}
          currentStep={currentStep}
          totalSteps={totalSteps}
          maxStepAvailable={maxStepAvailable}
          userToken={props.user.token}
        />
      )}
    </div>
  );
}

TrailDo.propTypes = {
  hideContainer: PropTypes.bool
};

TrailDo.defaultProps = {
  hideContainer: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TrailDo);
